export interface IHydrologicalNumberFormatter {
  (value:string|number, defaultText?:string):string;
}

export default function HydrologicalNumberFormatter() {
  return (input:string|number, defaultText:string = '---'):string => {
    if (input == null) {
      return defaultText;
    }
    const value = Number.parseFloat(input.toString());
    if (Number.isNaN(value)) {
      return defaultText;
    }
    if (value > 999) {
      return Math.round(value).toString();
    } else {
      return parseFloat(value.toPrecision(3)).toString();
    }
  };
}


/** WEBPACK FOOTER **
 ** ./app/utils/hydrological-number.formatter.ts
 **/